import { findGenerativeUiDescriptor } from '../registry';
import type { GenerativeUiDisplayMessage } from '../../../messages';

type GenerativeUiMessageProps = {
    message: GenerativeUiDisplayMessage;
};

/**
 * Renders a settled generative-UI reply by dispatching to its registered renderer.
 *
 * Together with renderGenerativeUiSelector (the composer-side equivalent), this is one of only
 * two places in the codebase that perform a registry lookup for rendering — every other consumer
 * goes through the message union, never a descriptor directly.
 */
export function GenerativeUiMessage({ message }: GenerativeUiMessageProps) {
    const descriptor = findGenerativeUiDescriptor(message.type);

    if (!descriptor) {
        // Unreachable in practice: normalizeMessage only produces a 'generativeUi' message
        // after a successful lookup for this same type, and reports+redirects to the
        // `unparseable` arm otherwise. This check exists only because findGenerativeUiDescriptor
        // takes a plain `string`, so TS cannot carry proof of registration across that boundary.
        // Reporting already happened in the normalizer — this stays silent, not a second report.
        return null;
    }

    return descriptor.render(message.data);
}
